// Functions
import VerifyToken from "../../config/verifyToken";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import PrescriptionsView from "../../components/prescriptions";

const PrescriptionsApp = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <PrescriptionsView software="app" />
    </Main>
  </>
);

export default PrescriptionsApp;
